import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconKit } from '../../../../../assets/images/icons/icon_kit.svg';
import { ReactComponent as IconCalendar } from '../../../../../assets/images/icons/icon_calendar.svg';
import styles from './NanoValueProps.module.scss';
import ValuePropsBox from '../ValuePropsBox';
import { getFiGrowthBook, useIsGrowthBookEnabled } from '../../../../../lib/growthbook';

export default function NanoValueProps() {
  const { t } = useTranslation();
  const seriesThreePlusExperience = useIsGrowthBookEnabled()
    ? getFiGrowthBook().getFeatureValue<boolean>('series-three-plus-experience', false)
    : false;

  if (!window.location.pathname.includes('smart-collar')) {
    return null;
  }

  return (
    <div className={styles.valuePropsSection}>
      <ValuePropsBox
        className="nano-value-props"
        valueProps={[
          {
            icon: <IconKit />,
            text: (
              <div className={styles.valueProp}>
                <span className={styles.valuePropHeader}>
                  {seriesThreePlusExperience
                    ? t('fi_series_3_plus_collar_included_free')
                    : t('fi_series_3_collar_included_free')}
                </span>
              </div>
            ),
          },
          {
            icon: <IconCalendar />,
            text: (
              <div className={styles.valueProp}>
                <span className={styles.valuePropHeader}>{t('thirty_day_risk_free_trial_short')}</span>
              </div>
            ),
          },
        ]}
      />
    </div>
  );
}
